/**
 * Resource configuration per module.
 * Used by App.tsx to render Resources based on baseRoute.
 */
import hallBookings, { bookings } from "@/containers/bookings/hall-bookings";
import bookingPurpose from "@/containers/bookings/booking-purpose";
import halls from "@/containers/bookings/halls";
import blockedHallDates from "@/containers/bookings/blocked-hall-dates";
import rentBookingReceipt from "@/containers/bookings/rent-booking-receipt";
import tallyConfig from "@/containers/tally-config";
import bankTallyExport from "@/containers/bank-tally-export";
import lagatReceipt from "@/containers/lagat-receipt";
import DepositReceiptPrint from "@/containers/bookings/rent-booking-receipt/DepositReceiptPrint";
import RazaPrint from "@/containers/bookings/hall-bookings/HallBookingsRazaPrint";
import razaRequests from "@/containers/raza-requests";
import RazaRequestRazaPrint from "@/containers/raza-requests/RazaRequestRazaPrint";
import ConfirmationVoucher from "@/containers/bookings/hall-bookings/HallBookingsConfirmationVoucher";

import niyaaz from "@/containers/events/niyaaz";
import niyaazPirsa from "@/containers/events/pirsa-delivery";
import niyaazBookedSlots from "@/containers/events/niyaaz-booked-slots";
import receipt from "@/containers/events/receipt";
import vendorLedger from "@/containers/events/vendor-ledger";
import vendor from "@/containers/events/vendor";
import vendorType from "@/containers/events/vendor-type";
import event from "@/containers/events/event";
import eventSequences from "@/containers/events/event-sequences";

import staff from "@/containers/staff/staff";
import staffAttendance from "@/containers/staff/staff-attendance";
import employeeLeaveRequests from "@/containers/staff/leave-requests";
import leaveCalendar from "@/containers/staff/leave-calendar";
import myAttendance from "@/containers/staff/my-attendance";
import staffSettings from "@/containers/staff/staff-settings";
import officeHolidays from "@/containers/staff/office-holidays";
import payrollPeriods, { PayrollPayslipPage } from "@/containers/staff/payroll-periods";
import {
  OFFICE_HOLIDAYS_CREATE,
  OFFICE_HOLIDAYS_VIEW,
  PAYROLL_PERIODS_VIEW,
  STAFF_SETTINGS_VIEW,
} from "@/containers/staff/shared/staff-payroll-permissions";

import academicYears from "@/containers/madrasa/academic-years";
import madrasaSettings from "@/containers/madrasa/madrasa-settings";
import madrasaClasses from "@/containers/madrasa/classes";
import madrasaStudents from "@/containers/madrasa/students";
import madrasaEnrollments from "@/containers/madrasa/enrollments";
import feeHeads from "@/containers/madrasa/fee-heads";
import feeStructures from "@/containers/madrasa/fee-structures";
import feeCollect from "@/containers/madrasa/fee-collect";
import feeReceipts from "@/containers/madrasa/fee-receipts";
import feeLedger from "@/containers/madrasa/fee-reports/ledger-index";
import feeDefaulters from "@/containers/madrasa/fee-reports/defaulters-index";
import feeCollectionSummary from "@/containers/madrasa/fee-reports/summary-index";
import PromotePage from "@/containers/madrasa/enrollments/PromotePage";
import {
  MADRASA_CLASSES_CREATE,
  MADRASA_CLASSES_EDIT,
  MADRASA_CLASSES_VIEW,
  MADRASA_ENROLLMENTS_CREATE,
  MADRASA_ENROLLMENTS_EDIT,
  MADRASA_ENROLLMENTS_VIEW,
  MADRASA_FEE_SETUP_CREATE,
  MADRASA_FEE_SETUP_EDIT,
  MADRASA_FEE_SETUP_VIEW,
  MADRASA_FEES_CREATE,
  MADRASA_FEES_VIEW,
  MADRASA_SETTINGS_EDIT,
  MADRASA_SETTINGS_VIEW,
  MADRASA_STUDENTS_CREATE,
  MADRASA_STUDENTS_EDIT,
  MADRASA_STUDENTS_VIEW,
} from "@/containers/madrasa/shared/madrasa-permissions";

import sabilData from "@/containers/sabil/sabil-data";
import sabilReceipt from "@/containers/sabil/sabil-receipt";
import sabilTakhmeen from "@/containers/sabil/sabil-takhmeen";
import sabilChangeRequests from "@/containers/sabil/sabil-change-request";
import sabilLedger from "@/containers/sabil/sabil-ledger";
import sabilAuditResource from "@/containers/sabil/sabil-audit";

import fmbData from "@/containers/fmb/fmb-data";
import fmbThali from "@/containers/fmb/fmb-thali";
import fmbReceipt from "@/containers/fmb/fmb-receipt";
import fmbTakhmeen from "@/containers/fmb/fmb-takhmeen";
import fmbContributions from "@/containers/fmb/fmb-contributions";
import fmbZabihatBookedSlots from "@/containers/fmb/fmb-zabihat-booked-slots";
import fmbDeliveryScheduleProfile from "@/containers/fmb/fmb-delivery-schedule-profile";
import fmbThaliSettings from "@/containers/fmb/fmb-thali-settings";
import fmbThaliDelivery from "@/containers/fmb/fmb-thali-delivery";
import fmbThaliType from "@/containers/fmb/fmb-thali-type";
import fmbContributionCategory from "@/containers/fmb/fmb-contribution-category";
import fmbDish from "@/containers/fmb/fmb-dish";
import fmbDailyMenu from "@/containers/fmb/fmb-daily-menu";
import fmbThaliDistributor from "@/containers/fmb/fmb-thali-distributor";
import fmbThaliDistributionDailyRun from "@/containers/fmb/fmb-thali-distribution-daily-run";
import fmbVendor from "@/containers/fmb/fmb-vendor";
import fmbVendorPaymentVoucher from "@/containers/fmb/fmb-vendor-payment-voucher";
import miqaats from "@/containers/miqaat-rsvp/miqaats";
import miqaatAttendance from "@/containers/miqaat-rsvp/miqaat-attendance";
import miqaatVenues from "@/containers/miqaat-rsvp/miqaat-venues";

import yearlyNiyaaz from "@/containers/yearly-niyaaz/yearly-niyaaz";
import yearlyNiyaazReceipts from "@/containers/yearly-niyaaz/yearly-niyaaz-receipts";
import yearlyNiyaazSettings from "@/containers/yearly-niyaaz/yearly-niyaaz-settings";
import YearlyNiyaazReceiptPrint from "@/containers/yearly-niyaaz/yearly-niyaaz-receipts/YearlyNiyaazReceiptPrint";
import yearlyLedger from "@/containers/yearly-ledger";
import yearlyLedgerSettings from "@/containers/yearly-ledger/yearly-ledger-settings";

import projects from "@/containers/projects/projects";
import projectTakhmeens from "@/containers/projects/project-takhmeens";
import projectTakhmeenReceipts from "@/containers/projects/project-takhmeen-receipts";
import projectInayats from "@/containers/projects/project-inayats";
import projectPayments from "@/containers/projects/project-payments";
import projectKarzans from "@/containers/projects/project-karzans";
import projectKarzanRepayments from "@/containers/projects/project-karzan-repayments";

import relayAccessRequests from "@/containers/relay/relay-access-requests";
import relayEvents from "@/containers/relay/relay-events";

import houseVisitEvents from "@/containers/house-visits/events";
import houseVisitSlots from "@/containers/house-visits/slots";
import houseVisitStops from "@/containers/house-visits/stops";
import houseVisitDaily from "@/containers/house-visits/daily";

import razaEvents from "@/containers/raza/raza-events";
import razaEventsUpcoming from "@/containers/raza/raza-events-upcoming";
import razaEventsMissingSadarat from "@/containers/raza/raza-events-missing-sadarat";
import razaEventAttendances from "@/containers/raza/raza-event-attendances";
import sadarats from "@/containers/raza/sadarats";
import makhsoosItsData from "@/containers/raza/makhsoos-its-data";

import {
  moduleWithSections,
  type ModuleResourcesRegistry,
  type ModuleRuntimeShape,
} from "@/types/react-admin-config";

/**
 * Module resources keyed by baseRoute path.
 * Checked with `ModuleResourcesRegistry` so `menuSection` keys match each module’s `menuSections`.
 */
export const MODULE_RESOURCES = {
  bookings: moduleWithSections({
    menuSections: {
      raza: "Raza & events",
      bookings: "Bookings",
      receipts: "Receipts",
      setup: "Setup",
    },
    resources: [
      {
        permission: "bookings.view",
        resource: bookings,
        menuSection: "bookings",
        hideFromMenu: true,
      },
      { permission: "bookings.view", resource: hallBookings, menuSection: "bookings" },
      { permission: "bookings.view", resource: blockedHallDates, menuSection: "bookings" },
      {
        permission: "razaRequests.view",
        resource: razaRequests,
        createPermission: "razaRequests.create",
        menuSection: "raza",
      },
      {
        permission: "razaEvents.view",
        resource: razaEvents,
        createPermission: "razaEvents.create",
        menuSection: "raza",
      },
      {
        permissionsAny: ["razaEvents.view", "razaEventAttendance.view"],
        resource: razaEventsUpcoming,
        menuSection: "raza",
      },
      {
        permission: "razaEvents.view",
        resource: razaEventsMissingSadarat,
        menuSection: "raza",
      },
      {
        permission: "razaEventAttendance.view",
        resource: razaEventAttendances,
        createPermission: "razaEventAttendance.create",
        menuSection: "raza",
        hideFromMenu: true,
      },
      {
        permission: "bookingReceipts.view",
        resource: rentBookingReceipt,
        createPermission: "bookingReceipts.create",
        menuSection: "receipts",
      },
      {
        permission: "lagatReceipts.view",
        resource: lagatReceipt,
        createPermission: "bookingReceipts.create",
        menuSection: "receipts",
      },
      { permission: "halls.view", resource: bookingPurpose, menuSection: "setup" },
      {
        permission: "halls.view",
        resource: halls,
        createPermission: "halls.create",
        menuSection: "setup",
      },
      {
        permission: "sadarats.view",
        resource: sadarats,
        createPermission: "sadarats.create",
        menuSection: "setup",
      },
      {
        permission: "makhsoosItsData.view",
        resource: makhsoosItsData,
        createPermission: "makhsoosItsData.create",
        menuSection: "setup",
      },
    ],
    customRoutes: [
      { path: "/dep-rcpt/:id", element: DepositReceiptPrint },
      { path: "/raza-print/:id", element: RazaPrint },
      { path: "/raza-request-print/:id", element: RazaRequestRazaPrint },
      { path: "/confirmation-voucher/:id", element: ConfirmationVoucher },
    ],
  }),
  events: {
    resources: [
      {
        permission: "niyaaz.view",
        resource: niyaaz,
        requireRouteId: true,
      },
      {
        permission: "niyaaz.view",
        resource: niyaazPirsa,
        requireRouteId: true,
      },
      {
        permission: "niyaaz.view",
        resource: niyaazBookedSlots,
        requireRouteId: true,
      },
      {
        permission: "niyaazReceipts.view",
        resource: receipt,
        requireRouteId: true,
      },
      {
        permission: "vendorLedger.edit",
        resource: vendorLedger,
        requireRouteId: true,
      },
      { permission: "vendors.edit", resource: vendor },
      { permission: "vendorTypes.edit", resource: vendorType },
      { permission: null, resource: event, hideFromMenu: true },
      {
        permission: "event.view",
        resource: eventSequences,
        requireRouteId: true,
      },
    ],
  },
  staff: moduleWithSections({
    menuSections: {
      // Setup first: day basis / leave / holidays before payroll runs.
      setup: "Setup",
      payroll: "Payroll",
    },
    resources: [
      { permission: "employees.view", resource: staff },
      { permission: "employees.view", resource: staffAttendance },
      {
        permissionsAny: ["employees.view", "myAttendance.view"],
        resource: employeeLeaveRequests,
        createPermission: "employees.create",
        // Portal users need the Resource mounted for /show deep-links; keep inbox out of their menu.
        hideFromMenuUnlessPermission: "employees.view",
      },
      {
        permissionsAny: ["myAttendance.view", "employees.view"],
        resource: leaveCalendar,
      },
      { permission: "myAttendance.view", resource: myAttendance },
      {
        // Staff managers who onboard employees need setup before payroll perms are granted.
        permissionsAny: [STAFF_SETTINGS_VIEW, "employees.view"],
        resource: staffSettings,
        menuSection: "setup",
      },
      {
        permissionsAny: [OFFICE_HOLIDAYS_VIEW, "employees.view"],
        resource: officeHolidays,
        menuSection: "setup",
        createPermissionsAny: [OFFICE_HOLIDAYS_CREATE, "employees.edit"],
      },
      {
        permission: PAYROLL_PERIODS_VIEW,
        resource: payrollPeriods,
        menuSection: "payroll",
      },
    ],
    customRoutes: [
      {
        path: "/payrollPeriods/:id/payslip/:lineId",
        element: PayrollPayslipPage,
      },
    ],
  }),
  madrasa: moduleWithSections({
    menuSections: {
      students: "Students",
      fees: "Fees",
      reports: "Fee reports",
      setup: "Setup",
    },
    resources: [
      {
        permission: MADRASA_STUDENTS_VIEW,
        resource: madrasaStudents,
        createPermission: MADRASA_STUDENTS_CREATE,
        editPermission: MADRASA_STUDENTS_EDIT,
        menuSection: "students",
      },
      {
        permission: MADRASA_ENROLLMENTS_VIEW,
        resource: madrasaEnrollments,
        createPermission: MADRASA_ENROLLMENTS_CREATE,
        editPermission: MADRASA_ENROLLMENTS_EDIT,
        menuSection: "students",
      },
      {
        permission: MADRASA_FEES_CREATE,
        resource: feeCollect,
        menuSection: "fees",
      },
      {
        permission: MADRASA_FEES_VIEW,
        resource: feeReceipts,
        menuSection: "fees",
      },
      { permission: MADRASA_FEES_VIEW, resource: feeLedger, menuSection: "reports" },
      { permission: MADRASA_FEES_VIEW, resource: feeDefaulters, menuSection: "reports" },
      { permission: MADRASA_FEES_VIEW, resource: feeCollectionSummary, menuSection: "reports" },
      {
        permission: MADRASA_FEE_SETUP_VIEW,
        resource: feeHeads,
        createPermission: MADRASA_FEE_SETUP_CREATE,
        editPermission: MADRASA_FEE_SETUP_EDIT,
        menuSection: "fees",
      },
      {
        permission: MADRASA_FEE_SETUP_VIEW,
        resource: feeStructures,
        menuSection: "fees",
      },
      {
        permission: MADRASA_CLASSES_VIEW,
        resource: madrasaClasses,
        createPermission: MADRASA_CLASSES_CREATE,
        editPermission: MADRASA_CLASSES_EDIT,
        menuSection: "setup",
      },
      {
        permission: MADRASA_SETTINGS_VIEW,
        resource: academicYears,
        createPermission: MADRASA_SETTINGS_EDIT,
        editPermission: MADRASA_SETTINGS_EDIT,
        menuSection: "setup",
      },
      {
        permission: MADRASA_SETTINGS_VIEW,
        resource: madrasaSettings,
        menuSection: "setup",
      },
    ],
    customRoutes: [{ path: "/madrasaPromote", element: PromotePage, withLayout: true }],
  }),
  sabil: {
    resources: [
      { permission: "sabil.view", resource: sabilData },
      {
        permission: "sabilReceipts.view",
        resource: sabilReceipt,
        createPermission: "sabilReceipts.create",
        editPermission: "sabilReceipts.edit",
      },
      {
        permission: "sabil.view",
        resource: sabilTakhmeen,
        hideFromMenu: true,
      },
      { permission: "sabil.view", resource: sabilChangeRequests },
      {
        permission: "sabil.view",
        resource: sabilLedger,
        hideFromMenu: true,
      },
      {
        permission: "sabil.view",
        resource: sabilAuditResource,
        hideFromMenu: true,
      },
    ],
  },
  fmb: moduleWithSections({
    menuSections: {
      households: "Households",
      vendors: "Vendors",
      distribution: "Distribution",
      kitchen: "Kitchen",
      setup: "Setup",
    },
    resources: [
      {
        permission: "fmbData.view",
        resource: fmbData,
        createPermission: "fmbData.create",
        menuSection: "households",
      },
      {
        permission: "fmbData.view",
        resource: fmbThali,
        menuSection: "households",
      },
      {
        permission: "fmbReceipt.view",
        resource: fmbReceipt,
        createPermission: "fmbReceipt.create",
        menuSection: "households",
      },
      {
        permission: "fmbData.view",
        resource: fmbContributions,
        createPermission: "fmbData.edit",
        menuSection: "households",
      },
      {
        permission: "fmbData.view",
        resource: fmbZabihatBookedSlots,
        menuSection: "households",
      },
      {
        permission: "fmbData.view",
        resource: fmbTakhmeen,
        createPermission: "fmbData.edit",
        menuSection: "households",
      },
      {
        permissionsAny: ["fmbThaliDelivery.view", "fmbThaliDistribution.view"],
        resource: fmbThaliDelivery,
        menuSection: "distribution",
      },
      {
        permission: "fmbDeliveryScheduleProfile.view",
        resource: fmbDeliveryScheduleProfile,
        createPermission: "fmbDeliveryScheduleProfile.create",
        menuSection: "setup",
      },
      {
        permission: "fmbThaliType.view",
        resource: fmbThaliType,
        createPermission: "fmbThaliType.create",
        menuSection: "setup",
      },
      {
        permission: "fmbData.view",
        resource: fmbContributionCategory,
        createPermission: "fmbData.edit",
        menuSection: "setup",
      },
      { permission: "fmbThaliSettings.view", resource: fmbThaliSettings, menuSection: "setup" },
      {
        permission: "fmbDish.view",
        resource: fmbDish,
        createPermission: "fmbDish.create",
        menuSection: "kitchen",
      },
      {
        permission: "fmbDailyMenu.view",
        resource: fmbDailyMenu,
        createPermission: "fmbDailyMenu.create",
        menuSection: "kitchen",
      },
      {
        permission: "fmbThaliDistributor.view",
        resource: fmbThaliDistributor,
        createPermission: "fmbThaliDistributor.create",
        menuSection: "distribution",
      },
      {
        permission: "fmbThaliDistribution.view",
        resource: fmbThaliDistributionDailyRun,
        hideFromMenu: true,
      },
      {
        permission: "fmbVendor.view",
        resource: fmbVendor,
        createPermission: "fmbVendor.create",
        menuSection: "vendors",
      },
      {
        permission: "fmbVendorPaymentVoucher.view",
        resource: fmbVendorPaymentVoucher,
        createPermission: "fmbVendorPaymentVoucher.create",
        menuSection: "vendors",
      },
    ],
  }),
  miqaatRsvp: {
    resources: [
      {
        permission: "miqaats.view",
        resource: miqaats,
        createPermission: "miqaats.create",
      },
      {
        permission: "miqaatVenues.view",
        resource: miqaatVenues,
        createPermission: "miqaatVenues.create",
      },
      {
        permission: "miqaatAttendance.view",
        resource: miqaatAttendance,
        createPermission: "miqaatAttendance.create",
      },
    ],
  },
  yearlyNiyaaz: {
    resources: [
      {
        permission: "yearlyNiyaaz.view",
        resource: yearlyNiyaaz,
        createPermission: "yearlyNiyaaz.create",
      },
      {
        permission: "yearlyNiyaazReceipts.view",
        resource: yearlyNiyaazReceipts,
        createPermission: "yearlyNiyaazReceipts.create",
      },
      {
        permission: "yearlyNiyaaz.view",
        resource: yearlyNiyaazSettings,
      },
    ],
    customRoutes: [{ path: "/yn-rcpt/:id", element: YearlyNiyaazReceiptPrint }],
  },
  yearlyLedger: {
    resources: [
      {
        permission: "yearlyLedger.view",
        resource: yearlyLedger,
        createPermission: "yearlyLedger.create",
        hideFromMenu: true,
      },
      {
        permission: "yearlyLedger.view",
        resource: yearlyLedgerSettings,
      },
    ],
  },
  projects: moduleWithSections({
    menuSections: {
      overview: "Overview",
      finance: "Finance",
    },
    resources: [
      {
        permission: "projects.view",
        resource: projects,
        createPermission: "projects.create",
        menuSection: "overview",
        hideFromMenuWhenRouteId: true,
      },
      {
        permission: "projectTakhmeens.view",
        resource: projectTakhmeens,
        createPermission: "projectTakhmeens.create",
        menuSection: "finance",
        requireRouteId: true,
      },
      {
        permission: "projectTakhmeenReceipts.view",
        resource: projectTakhmeenReceipts,
        createPermission: "projectTakhmeenReceipts.create",
        menuSection: "finance",
        requireRouteId: true,
      },
      {
        permission: "projectInayats.view",
        resource: projectInayats,
        createPermission: "projectInayats.create",
        menuSection: "finance",
        requireRouteId: true,
      },
      {
        permissionsAny: ["projectPayments.view", "projects.view", "projects.edit", "projects.*"],
        resource: projectPayments,
        createPermissionsAny: ["projectPayments.create", "projects.edit", "projects.*"],
        menuSection: "finance",
        requireRouteId: true,
      },
      {
        permission: "projectKarzans.view",
        resource: projectKarzans,
        createPermission: "projectKarzans.create",
        menuSection: "finance",
        requireRouteId: true,
      },
      {
        permission: "projectKarzanRepayments.view",
        resource: projectKarzanRepayments,
        createPermission: "projectKarzanRepayments.create",
        menuSection: "finance",
        requireRouteId: true,
      },
    ],
  }),
  relay: {
    resources: [
      {
        permission: "relayEvents.view",
        resource: relayEvents,
        createPermission: "relayEvents.create",
      },
      {
        permission: "relayAccessRequests.view",
        resource: relayAccessRequests,
        createPermission: "relayAccessRequests.create",
      },
    ],
  },
  houseVisits: moduleWithSections({
    menuSections: {
      ops: "Operations",
      plan: "Planning",
    },
    resources: [
      {
        permission: "houseVisitEvents.view",
        resource: houseVisitEvents,
        createPermission: "houseVisitEvents.create",
        menuSection: "plan",
        hideFromMenuWhenRouteId: true,
      },
      {
        permissionsAny: ["houseVisitStops.view", "houseVisitSlots.view"],
        resource: houseVisitDaily,
        menuSection: "ops",
        requireRouteId: true,
      },
      {
        permission: "houseVisitSlots.view",
        resource: houseVisitSlots,
        createPermission: "houseVisitSlots.create",
        menuSection: "plan",
        requireRouteId: true,
      },
      {
        permission: "houseVisitStops.view",
        resource: houseVisitStops,
        createPermission: "houseVisitStops.create",
        hideFromMenu: true,
        requireRouteId: true,
      },
    ],
  }),
  accounts: moduleWithSections({
    menuSections: {
      setup: "Setup",
    },
    resources: [
      {
        permission: "sabilReceipts.view",
        resource: sabilReceipt,
        createPermission: "sabilReceipts.create",
        editPermission: "sabilReceipts.edit",
      },
      {
        permission: "lagatReceipts.view",
        resource: lagatReceipt,
        createPermission: "lagatReceipts.create",
      },
      {
        permission: "bookingReceipts.view",
        resource: rentBookingReceipt,
        createPermission: "bookingReceipts.create",
      },
      {
        permission: "niyaazReceipts.view",
        // List/export only under Accounts — create requires an event context (Events module).
        resource: {
          ...receipt,
          create: null,
          label: "Niyaaz Event Receipts",
          options: { label: "Niyaaz Event Receipts" },
        },
      },
      {
        permission: "yearlyNiyaazReceipts.view",
        resource: yearlyNiyaazReceipts,
        createPermission: "yearlyNiyaazReceipts.create",
      },
      {
        permission: "fmbReceipt.view",
        resource: fmbReceipt,
        createPermission: "fmbReceipt.create",
      },
      {
        permission: "tallyConfig.view",
        resource: tallyConfig,
        menuSection: "setup",
      },
      {
        permission: "tallyConfig.view",
        resource: bankTallyExport,
        menuSection: "setup",
      },
    ],
  }),
} satisfies ModuleResourcesRegistry;

export type ModuleResourcesKey = keyof typeof MODULE_RESOURCES;

export function isModuleResourcesKey(s: string): s is ModuleResourcesKey {
  return Object.prototype.hasOwnProperty.call(MODULE_RESOURCES, s);
}

/** Resolved module bundle for `baseRoute`, or `undefined` if not a configured module. */
export function getModuleRuntimeShape(
  baseRoute: string | null | undefined
): ModuleRuntimeShape | undefined {
  if (baseRoute == null || !isModuleResourcesKey(baseRoute)) {
    return undefined;
  }
  return MODULE_RESOURCES[baseRoute] as ModuleRuntimeShape;
}
